<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame">
        <span style="font-size: 15px; color: #606266">
          {{ $l('INDEX.booking_container_title') || '装柜PO' }}
        </span>
      </div>
    </div>
    <b-row align-h="between">
      <b-col cols="7">
        <b-input-group size="sm">
          <!-- <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="exportExcel()"
          >
            <i class="el-icon-folder-opened"></i>
            {{ $l('INDEX.btn_export') || '导出' }}
          </b-button> -->
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
}
</script>
